var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:('color: ' + _vm.Status.status[_vm.dominio.status].color)},[_vm._v(" "+_vm._s(_vm.Status.status[_vm.dominio.status].label)+" "),(_vm.dominio.status === _vm.Status.STATUS_AGUARDANDO_REGISTRO)?_c('i',{staticClass:"fa fa-timer text-warning"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }